const DeleteGantt = async (taskOriginal, id, gantt, thiss) => {
  await thiss.validateSupervisor(
    taskOriginal[0].owner_id,
    thiss.currentUser.EmployeeId
  );
  var task = gantt.getTask(id);
  // console.log("qwq", thiss.isSupervisor, isSupervisor);
  if (
    thiss.currentUser.EmployeeId != task.created_by &&
    thiss.currentUser.PositionID != 16 &&
    task.parent == 0
  ) {
    gantt.alert({
      text: `Usted no es el creador de ${
        taskOriginal[0].parent ? " esta tarea " : " este objetivo "
      } para poder eliminarla.`,
      title: "Error!",
      ok: "OK",
      type: "error"
    });
    return false;
  } else if (
    !thiss.isSupervisor &&
    // thiss.currentUser.EmployeeId != 37 &&
    thiss.currentUser.PositionID != 16 &&
    thiss.currentUser.EmployeeId != task.created_by &&
    task.parent != 0
  ) {
    gantt.alert({
      text: `Usted no supervisar a este colaborador para poder eliminar la tarea.`,
      title: "Error!",
      ok: "OK",
      type: "error"
    });
    return false;
  }
  gantt.confirm({
    text: taskOriginal[0].parent
      ? "Seguro que deseas eliminar esta tarea?"
      : "Seguro que deseas eliminar este objetivo?",
    ok: "Si",
    cancel: "No",
    callback: function (result) {
      if (result) {
        thiss.loading = true;
        var task = gantt.getTask(id);
        // console.log("ok", task);
        // var dateToStr = gantt.date.date_to_str("%d-%m-%Y");
        gantt.hideLightbox();
        if (task.parent != 0) {
          if (task.parent.includes("Task")) {
            //SubTasks
            thiss.$http
              .delete(`/api/CMI/SubTaskGantt/DeleteSubGanttTask?ID=${id}`)
              .then((resp) => {
                thiss.$message({
                  type: "success",
                  message: resp.data
                });
              })
              .catch((err) => {
                thiss.$message({
                  type: "error",
                  message: err.message
                });
                console.error(err);
              })
              .finally(() => {
                thiss.GetGanttObjectives();
                // thiss.loading = false;
                thiss.isSupervisor = false;
              });
            return true;
          }
          thiss.$http
            .delete(`/api/CMI/Task/DeleteGanttTask?TaskID=${id}`)
            .then((resp) => {
              thiss.$message({
                type: "success",
                message: resp.data
              });
            })
            .catch((err) => {
              thiss.$message({
                type: "error",
                message: err.message
              });
              console.error(err);
            })
            .finally(() => {
              thiss.GetGanttObjectives();
              // thiss.loading = false;
              thiss.isSupervisor = false;
            });
          return true;
        }
        thiss.$http
          .post(
            `/api/CMI/Objetives/deleteGantt?id=${id}&employeeId=${thiss.currentUser.EmployeeId}`
          )
          .then(() => {
            thiss.$message({
              type: "success",
              message: "Objetivo removido"
            });
          })
          .catch((err) => {
            thiss.$message({
              type: "error",
              message: err.message
            });
          })
          .finally(() => {
            thiss.GetGanttObjectives();
            // thiss.loading = false;
            thiss.isSupervisor = false;
          });

        return true;
      } else {
        true;
      }
    }
  });
  return true;
};
export default DeleteGantt;
